module.exports = __webpack_public_path__ + "media/robin.dde41d01.mp3";